import { Pipe, PipeTransform } from '@angular/core';
import { WidgetSelection } from '../models/dashboard.models';

@Pipe({ name: 'getSelectedWidgetClass', standalone: true, pure: false })
export class GetSelectedWidgetClassPipe implements PipeTransform {
  transform(widgets: WidgetSelection[], widgetId: string, cartridgeId: string | undefined | null): boolean {
    return widgets.some(
      ({ widgetId: id, cartridgeId: cId }) => id === widgetId && (cartridgeId == null || cId === cartridgeId)
    );
  }
}
